import { customer } from '../';

export const getTitle = state => state.ui.title;
export const getDateFormat = state => state.ui.formats.date; 
export const getLocation = state => state.router.location;
export const getLocationPath = state => state.router.location.pathname;

export const isNumericKeyPress = (e) => e.which >= 48 && e.which <= 57;
export const isCtrlCKeyPress = (e) => e.key === "c" && e.ctrlKey;
export const isCtrlVKeyPress = (e) => e.key === "v" && e.ctrlKey;

export const getUrlForCustomer = (customerId, page, prefix = true) => `${prefix? '#': ''}/customer/${customerId}/${page}`;

export const getUrl = (state, page) => {
    const id = customer.profile.selectors.getCustomerID(state);
    return getUrlForCustomer(id, page);
}